import React, { useState, useEffect } from 'react';
import MILAMI_LOGO_URL from '../assets/images/background01.png';
import { ArrowUpCircle } from 'lucide-react';

function Footer() {
  const [showScrollToTopButton, setShowScrollToTopButton] = useState(false);
  
  const handleScroll = () => {
    const rootElement = document.getElementById('root');
    if (rootElement) {
      if (rootElement.scrollTop > 300) {
        setShowScrollToTopButton(true);
      } else {
        setShowScrollToTopButton(false);
      }
    }
  };

  const scrollToTop = () => {
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.scrollTo({
        top: 0,
        behavior: 'smooth' 
      });
    }
  };

  useEffect(() => {
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (rootElement) {
        rootElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []); 

  return (
    <footer className="bg-slate-900 text-slate-400 py-6 px-4 text-center flex-shrink-0 relative border-t border-slate-800">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        
        <div className="flex flex-col items-center gap-1.5"> 
          <div className="flex items-center gap-2.5">
            <div 
              className="h-6 w-6 bg-white flex items-center justify-center shrink-0"
              style={{ clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' }}
            >
              <img 
                src={MILAMI_LOGO_URL} 
                alt="iLAMI Logo" 
                className="h-full w-full object-contain p-[2px]" 
              />
            </div>
            
            <p className="text-sm text-slate-300 font-medium">
              <span className="text-slate-50 font-bold">iLAMI <span className="text-blue-500 font-normal">Technologies</span></span> &copy; {new Date().getFullYear()}. All rights reserved.
            </p>
          </div>
          <p className="mt-1 text-[10px] text-slate-500 uppercase tracking-widest">
            Innovating for a brighter digital future.
          </p>
        </div>
      </div>
      {showScrollToTopButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 bg-slate-800 p-3 rounded-full shadow-2xl text-slate-100
                     hover:bg-slate-700 hover:text-white transition-all duration-300 ease-in-out z-40
                     flex items-center justify-center border border-slate-700 transform hover:-translate-y-1"
          aria-label="Scroll to top"
          title="Scroll to top"
        >
          <ArrowUpCircle size={28} strokeWidth={1.5} />
        </button>
      )}
    </footer>
  );
}

export default Footer;